import {
    actionEffect,
    ListenerMiddleware,
    registerActionEffect,
} from 'store/listenerMiddleware';
import { ApiRequestOptions } from 'communication/ApiCallInfo';
import { setBuildVersion } from './generalAppStateSlice';
import { isAnyOf } from '@reduxjs/toolkit';
import { addAvailabilityStatus } from '../connectivity/connectivityStateSlice';

export const fetchBuildVersionOnAvailabilityStatusReadyReceivedEffect =
    actionEffect(
        isAnyOf(addAvailabilityStatus),
        async (action, dispatch, state, services) => {
            const { status } = action.payload;
            if (status !== 'READY') {
                return;
            }

            const { indigoServiceClient, requestProgressService } = services;
            const version =
                await requestProgressService.invokeAndMonitorRequest(
                    'version',
                    (options: ApiRequestOptions) => {
                        return indigoServiceClient.get<string>(
                            'version',
                            options
                        );
                    }
                );

            if (version) {
                dispatch(setBuildVersion(version));
            }
        }
    );

export function registerGeneralAppEffects(middleware: ListenerMiddleware) {
    registerActionEffect(
        middleware,
        fetchBuildVersionOnAvailabilityStatusReadyReceivedEffect
    );
}
